
const Main = () => import('@/views/main');
const sitePages = () => import('@/views/platform/site');
const ticketPages = () => import('@/views/platform/ticket');
const couponPages = () => import('@/views/platform/coupon');
const addBranchStore = () => import('@/views/platform/addBranchStore');
const addTicket = () => import('@/views/platform/addTicket');
const newAddCoupon = () => import('@/views/platform/newAddCoupons');
const couponUserShare = () => import('@/views/platform/coupon-user-share');
const couponUserDiscount = () => import('@/views/platform/coupon-user-discount');
const storedValue = () => import('@/views/platform/stored-value');
const storedValueConfig = () => import('@/views/platform/stored-value-config');
const storedPhoto = () => import('@/views/platform/stored-photo');
const groupPhoto = () => import('@/views/platform/group-photo');
const calendar = () => import('@/views/platform/calendar');
const calendarSet = () => import('@/views/platform/calendar-set');
const specialBusinessSet = () => import('@/views/platform/special-business-set');
const specialBusiness = () => import('@/views/platform/special-business');


export default [{
	path: '/totalPlatform',
	name: 'totalPlatform',
	component: Main,
	redirect: {
		name: 'sitePages'
	},
	meta: {
		hide: false,
		name: '总平台管理',
		unfold: true,
		iconType: "7"
	},
	children: [
		{
			path: 'sitePages',
			name: 'sitePages',
			component: sitePages,
			meta: {
				name: '场地管理'
			},
			children: [
				{
					path: "addBranchStore",
					component: addBranchStore,
					name: "addBranchStore",
					meta: {
						name: '新增场地'
					},
				},
				{
					path: "updateBranchStore",
					component: addBranchStore,
					name: "updateBranchStore",
					meta: {
						name: '编辑场地'
					},
				},
				{
					path: "detailBranchStore",
					component: addBranchStore,
					name: "detailBranchStore",
					meta: {
						name: '场地详情'
					},
				},
				{
					path: "storedPhoto/:id",
					component: storedPhoto,
					name: "storedPhoto",
					meta: {
						name: '门店相册管理'
					},
					children: [
						{
							path: "groupPhoto",
							component: groupPhoto,
							name: "groupPhoto",
							meta: {
								name: "分组图片"
							}
						}
					]
				},
				{
					path: "specialBusiness",
					component: specialBusiness,
					name: "specialBusiness",
					meta: {
						name: '特殊营业时间'
					},
					children: [
						{
							path: "addSpecialBusiness",
							component: specialBusinessSet,
							name: "addSpecialBusiness",
							meta: {
								name: '新增营业时间'
							}
						},
					]
				},
				{
					path: "specialBusinessSet",
					component: specialBusinessSet,
					name: "specialBusinessSet",
					meta: {
						name: '特殊营业时间设置'
					},
				},
			]

		},
		{
			path: 'ticket',
			name: 'ticket',
			component: ticketPages,
			meta: {
				name: '票券管理'
			},
			children: [
				{
					path: "addTicket",
					component: addTicket,
					name: "addTicket",
					meta: {
						name: '新增票券'
					},
				},
				{
					path: "updateTicket",
					component: addTicket,
					name: "updateTicket",
					meta: {
						name: '编辑票券'
					},
				},
				{
					path: "detailTicket",
					component: addTicket,
					name: "detailTicket",
					meta: {
						name: '票券详情'
					},
				},
			]
		},
		// {
		// 	path: '/coupon',
		// 	name: 'coupon',
		// 	component: couponPages,
		// 	meta: {
		// 		name: '优惠券管理'
		// 	},
		// 	children: [
		// 		{
		// 			path: "newAddCoupon",
		// 			component: newAddCoupon,
		// 			name: "newAddCoupon",
		// 			meta: {
		// 				name: '新增优惠券'
		// 			},
		// 		},
		// 		{
		// 			path: "couponDetail",
		// 			component: newAddCoupon,
		// 			name: "couponDetail",
		// 			meta: {
		// 				name: '优惠券详情'
		// 			},
		// 		},
		// 		{
		// 			path: "couponUserShare",
		// 			component: couponUserShare,
		// 			name: "couponUserShare",
		// 			meta: {
		// 				name: '分发用户查看'
		// 			},
		// 		},
		// 		{
		// 			path: "couponUserDiscount",
		// 			component: couponUserDiscount,
		// 			name: "couponUserDiscount",
		// 			meta: {
		// 				name: '分发用户查看'
		// 			},
		// 		},
		// 	]
		// },
		// {
		// 	path: 'storedValue',
		// 	name: 'storedValue',
		// 	component: storedValue,
		// 	meta: {
		// 		name: '储值配置'
		// 	},
		// 	children: [
		// 		{
		// 			path: "storedValueConfig",
		// 			component: storedValueConfig,
		// 			name: "storedValueConfig",
		// 			meta: {
		// 				name: '储值规则设置'
		// 			}
		// 		}
		// 	]
		// },
		// {
		// 	path: 'calendar',
		// 	name: 'calendar',
		// 	component: calendar,
		// 	meta: {
		// 		name: '日期类型管理'
		// 	},
		// 	children: [
		// 		{
		// 			path: "calendarSet",
		// 			component: calendarSet,
		// 			name: "calendarSet",
		// 			meta: {
		// 				name: '批量设置日期'
		// 			}
		// 		}
		// 	]
		// },
	]
}]

